import {userKeepalive, userMe, userLogout} from '../api/user.api';
import Cookie from '../../../system/cookie';

const AUTH_COOKIE = 'DOMOVIO_AUTH_TOKEN';

export default {
    namespaced: true,
    state:      {
        token:      Cookie.get(AUTH_COOKIE) || null,
        isLoggedIn: false,
        me:         null,
    },
    getters:    {
        /**
         * @param {Object} state
         * @return {boolean}
         */
        isLoggedIn: (state) => state.isLoggedIn && state.me,
        /**
         * @param {Object} state
         * @return {Object|null}
         */
        me:         (state) => state.me,
        /**
         * @param {Object} state
         * @return {String|null}
         */
        token:      (state) => state.token,
    },
    actions:    {
        /**
         * @param {Function} commit
         * @param {String} token
         */
        setToken({commit}, token) {
            commit('SET_TOKEN', token);
        },
        /**
         * @param {Function} dispatch
         * @return {Promise<void>}
         */
        async init({dispatch}) {
            await dispatch('checkStatus');
            await dispatch('me');
            setInterval(() => dispatch('checkStatus'), 30000);
            setInterval(() => dispatch('me'), 60000);
        },
        /**
         * @param {Function} commit
         * @return {Promise<void>}
         */
        async checkStatus({commit}) {
            try {
                await userKeepalive();
                commit('SET_STATUS', true);
            } catch (e) {
                commit('SET_STATUS', false);
            }
        },
        /**
         * @param {Function} commit
         * @return {Promise<void>}
         */
        async me({commit}) {
            try {
                const data = await userMe();
                commit('SET_ME', data.data);
            } catch (e) {
                commit('SET_ME', null);
            }
        },
        /**
         * @param {Function} commit
         * @return {Promise<void>}
         */
        async logout({commit}) {
            await userLogout();
            commit('SET_TOKEN', null);
            commit('SET_ME', null);
            commit('SET_STATUS', false);
        }
    },
    mutations:  {
        /**
         * @param {Object} state
         * @param {Boolean} status
         * @return {*}
         * @constructor
         */
        SET_STATUS: (state, status) => state.isLoggedIn = status,
        /**
         * @param {Object} state
         * @param {Object|null} data
         * @return {*}
         * @constructor
         */
        SET_ME:     (state, data) => state.me = data,
        /**
         * @param {Object} state
         * @param {Object|null} token
         * @return {*}
         * @constructor
         */
        SET_TOKEN:  (state, token) => state.token = token,
    }
}
